import { Formik } from 'formik';
import React from 'react';
import { Form } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import * as yup from 'yup';
import { PromoterEditAddressFormStep } from './PromoterEditAddressFormStep';

export function PromoterEditAddressForm({
  promoter,
  profiles,
  countries,
  districts,
  counties,
  parishes,
  handleDistrictChange,
  handleCountyChange,
  onSubmit,
  savePromoter,
  setError,
}) {
  return (
    <div className='mb-5'>
      <h2 className='mb-1 text-secondary'>
        <FormattedMessage id='promoterAddress.change.title' />
      </h2>
      <br />

      <Formik
        initialValues={promoter}
        validateOnBlur={false}
        validateOnChange={false}
        validationSchema={promoterFormSchema}
        onSubmit={(values, { setSubmitting, setErrors }) => {
          onSubmit(values, setSubmitting, setErrors);
        }}>
        {(formikProps) => (
          <Form onSubmit={formikProps.handleSubmit}>
            <PromoterEditAddressFormStep
              {...formikProps}
              values={formikProps.values}
              districts={districts}
              counties={counties}
              parishes={parishes}
              onDistrictChange={handleDistrictChange}
              onCountyChange={handleCountyChange}
              savePromoter={savePromoter}
            />
          </Form>
        )}
      </Formik>
    </div>
  );
}



const promoterFormSchema = yup.object().shape({
    address: yup.string().required(<FormattedMessage id='errors.fieldRequiredText' />),
    district: yup
        .string()
        .test(
          'isValidDistrict',
          <FormattedMessage id='errors.promoterForm.district' />,
          (value) => value !== '-1'
        ),
    county: yup
        .string()
        .test(
          'isValidCounty',
          <FormattedMessage id='errors.promoterForm.county' />,
          (value) => value !== '-1'
        ),
    parish: yup
        .string()
        .test(
          'isValidParish',
          <FormattedMessage id='errors.promoterForm.parish' />,
          (value) => value !== '-1'
        ),
    postalCode: yup
        .string()
        .required(<FormattedMessage id='errors.fieldRequiredText' />)
        .test(
          'isValidPostCode',
          <FormattedMessage id='errors.postalCode'/>,
          (postalCode) => new RegExp(/^\d{4}-\d{3}$/).test(postalCode)
        ),
  });
